import { memo } from 'react'

export default memo(function EditIcon(props: any) {
  return (
    <svg
      width={props.size || 32}
      height={props.size || 32}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 22.8H25.3V12C25.3 11.3 24.7 10.8 24.1 10.8C23.5 10.8 22.9 11.4 22.9 12V22.8H12C11.3 22.8 10.8 23.4 10.8 24C10.8 24.6 11.4 25.2 12 25.2H22.8V36C22.8 36.7 23.4 37.2 24 37.2C24.6 37.2 25.2 36.6 25.2 36V25.3H36C36.7 25.3 37.2 24.7 37.2 24.1C37.2 23.5 36.7 22.8 36 22.8Z"
        fill={props.color || '#888'}
      ></path>
    </svg>
  )
})
